import React from 'react';
import styled from 'styled-components';
import { useSidebar } from '../contexts/SidebarContext';

const CustomModal = ({
  isOpen,
  onClose,
  children,
  size = 'medium',
  title,
  showCloseButton = true,
  closeOnOverlayClick = true,
}) => {
  const { isOpen: sidebarOpen } = useSidebar();

  const handleOverlayClick = e => {
    if (closeOnOverlayClick && e.target === e.currentTarget) {
      onClose();
    }
  };

  if (!isOpen) return null;

  return (
    <ModalContainer $sidebarOpen={sidebarOpen}>
      <ModalOverlay onClick={handleOverlayClick} />
      <ModalContent size={size}>
        {title && (
          <ModalHeader>
            {title}
            {showCloseButton && (
              <CloseButton onClick={onClose} aria-label="Close modal">
                ×
              </CloseButton>
            )}
          </ModalHeader>
        )}
        {children}
      </ModalContent>
    </ModalContainer>
  );
};

// Styled Components
const ModalContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  box-sizing: border-box;

  /* Account for sidebar width */
  padding-left: ${props => (props.$sidebarOpen ? '270px' : '70px')};
  transition: padding-left 0.3s ease-in-out;
`;

const ModalOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(2px);
`;

const ModalContent = styled.div`
  position: relative;
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  max-width: ${props => {
    switch (props.size) {
      case 'small':
        return '500px';
      case 'large':
        return '1000px';
      case 'full':
        return '95vw';
      default:
        return '800px';
    }
  }};
  width: 100%;
  max-height: 90vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  z-index: 10001;
`;

const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 1px solid #e0e0e0;
  background-color: #fafafa;
  font-family: 'Poppins', sans-serif;
  font-size: 18px;
  font-weight: 600;
  color: #333;
`;

const CloseButton = styled.button`
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #666;
  padding: 0;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: all 0.2s ease;

  &:hover {
    background-color: #e0e0e0;
    color: #333;
  }
`;

// Export styled components for use in other components
export const ModalBody = styled.div`
  padding: 24px;
  overflow-y: auto;
  flex: 1;
`;

export const ModalActions = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 16px 24px;
  border-top: 1px solid #e0e0e0;
  background-color: #fafafa;
  gap: 12px;
`;

export default CustomModal;
